var zIndex = {
  negative: -1,
  default: 1,
  header: 5,
  overlay: 1000,
  navigation: 2000,
  navigationContent: 2001,
  drawer: 3000,
  modal: 5000,
  tooltip: 6000,
  toast: 8000
};
export { zIndex as default, zIndex };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
